import { Component } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { BaseModal } from "@app/shared/cerrix-modal/BaseModal";
import { ThirdPartyModel } from "@models/thirdparty/ThirdpartyModel";
import { EntityModel } from "@app/datamanagement/models/EntityModel";

@Component({
    selector: "thirdparty-dialog",
    templateUrl: "./thirdparty-dialog.component.html",
    styleUrls: ["./thirdparty-dialog.component.scss"],
    imports: [NgSelectModule],
})
export class ThirdPartyDialogComponent extends BaseModal {
    thirdparties: EntityModel[];

    changed(currentSelection: EntityModel[]) {
        const currentSelectedIds = currentSelection.map((x) => x.id);
        this.thirdparties.forEach((x) => {
            x.selected = currentSelectedIds.indexOf(x.id) > -1;
        });
    }

    okClick() {
        this._bsModalRef.hide();

        super.onConfirm(this.thirdparties.filter((x) => x.selected));
    }

    closeClick() {
        super.onCancel();
    }
}
